import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
interface MessageAndInstructionsProps {
  formData: any;
  onMessageChange: (message: string) => void;
}
const MessageAndInstructions: React.FC<MessageAndInstructionsProps> = t0 => {
  const $ = _c(22);
  const {
    formData,
    onMessageChange
  } = t0;
  const [message, setMessage] = useState(formData.selectedMessage || "");
  let t1;
  let t2;
  if ($[0] !== formData.selectedMessage) {
    t1 = () => {
      setMessage(formData.selectedMessage || "");
    };
    t2 = [formData.selectedMessage];
    $[0] = formData.selectedMessage;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const getWordCount = _temp2;
  const wordCount = getWordCount(message);
  const isOverLimit = wordCount > 200;
  let t3;
  if ($[3] !== onMessageChange) {
    t3 = e => {
      const newMessage = e.target.value;
      setMessage(newMessage);
      onMessageChange(newMessage);
    };
    $[3] = onMessageChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleMessageChange = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h2 className="text-[#303030] lg:text-lg text-xs font-normal font-outfit">Write a message here</h2>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `w-full outline-none px-3 py-2 appearance-none no-scrollbar border-[1px] rounded-md placeholder:text-sm text-sm ${isOverLimit ? "border-red-300 bg-red-50" : "border-[#D9D9D9]"}`;
  let t6;
  if ($[6] !== handleMessageChange || $[7] !== message || $[8] !== t5) {
    t6 = <textarea value={message} onChange={handleMessageChange} placeholder="Write a custom message here..." className={t5} rows={3} maxLength={1000} />;
    $[6] = handleMessageChange;
    $[7] = message;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = `${isOverLimit ? "text-red-500" : "text-gray-500"}`;
  const t8 = isOverLimit && "(Limit exceeded)";
  let t9;
  if ($[10] !== t7 || $[11] !== t8 || $[12] !== wordCount) {
    t9 = <div className={t7}>{wordCount}/200 words {t8}</div>;
    $[10] = t7;
    $[11] = t8;
    $[12] = wordCount;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== isOverLimit) {
    t10 = isOverLimit && <div className="text-red-500 text-xs">Please reduce text to 200 words or less</div>;
    $[14] = isOverLimit;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className="flex justify-between items-center text-xs">{t9}{t10}</div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t6) {
    t12 = <div className="space-y-3">{t4}<div className="space-y-2">{t6}{t11}</div></div>;
    $[19] = t11;
    $[20] = t6;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};
export default MessageAndInstructions;
function _temp(word) {
  return word.length > 0;
}
function _temp2(text) {
  return text.trim().split(/\s+/).filter(_temp).length;
}